import { Volume2, VolumeX } from "lucide-react";

export default function VideoMuteToggle({ muted, onToggle }) {
  return (
    <button
      onClick={onToggle}
      className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-black/55 hover:bg-black/75 text-white flex items-center justify-center transition"
      data-testid="showcase-mute-btn"
      aria-label="Mute / unmute"
    >
      {muted ? <VolumeX className="w-5 h-5" /> : <Volume2 className="w-5 h-5" />}
    </button>
  );
}
